import { useState } from "react";
import type { EventView, ParticipantView } from "../api/types.js";

interface Props {
  event: EventView;
  participant: ParticipantView;
  submitting: boolean;
  error: string | null;
  onSubmit: (displayName: string) => void;
}

/** 初回アクセス時の表示名登録 */
export function NameScreen({
  event,
  participant,
  submitting,
  error,
  onSubmit,
}: Props): React.ReactElement {
  const [name, setName] = useState("");
  const trimmed = name.trim();

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (submitting || trimmed === "") return;
    onSubmit(trimmed);
  };

  return (
    <div className="centered">
      <form className="centered__box" onSubmit={handleSubmit}>
        <p className="name__event">{event.name}</p>
        <h1 className="name__title">お名前を入力してください</h1>
        {participant.team !== null && (
          <p className="name__team">チーム：{participant.team.name}</p>
        )}
        {participant.seatNo !== null && (
          <p className="name__seat">席番号：{participant.seatNo}</p>
        )}

        <input
          type="text"
          className="answer-form__input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="例）山田太郎"
          maxLength={50}
          disabled={submitting}
          autoCapitalize="off"
          autoCorrect="off"
          enterKeyHint="done"
          aria-label="お名前"
        />

        {error !== null && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}

        <button
          type="submit"
          className="btn btn--primary btn--block"
          disabled={submitting || trimmed === ""}
        >
          {submitting ? "登録中…" : "はじめる"}
        </button>

        <p className="name__note">
          入力した名前は、得点表やチームメンバーの画面に表示されます。
        </p>
      </form>
    </div>
  );
}
